<template>
    <v-dialog v-model="dialog" fullscreen  hide-overlay transition="dialog-bottom-transition">
        <v-card >
            <v-toolbar dark color="primary">
                <v-toolbar-title>Recuperar Contraseña</v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn icon  @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-layout wrap justify-center px-4>

                <v-flex xs12 sm8 md6 xl4 mt-4>
                    <v-sheet class="mt-4" v-if="passwordRecoverySuccess">
                        <p class="text-center">Solicitud enviada exitosamente, por favor revisa tu bandeja de entrada.</p>
                    </v-sheet>
                    <v-form
                            v-else
                            v-model="valid">
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field
                                        @keydown.enter.prevent.stop="passwordRecovery"
                                        :loading="loadingPasswordRecovery"
                                        v-model="email"
                                        :rules="emailRules"
                                        label="E-mail"
                                        placeholder="Ingresa tu correo"
                                        :readonly="loadingPasswordRecovery"
                                        required
                                        clearable
                                        append-icon="send"
                                        @click:append="passwordRecovery"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-flex>
            </v-layout>
        </v-card>
    </v-dialog>
</template>

<script>
    import {ApiUtils} from '@/utils/ApiUtils'
    import {mapMutations} from 'vuex'
    export default{
        components: {},
        data(){
            return {
                dialog: false,
                valid: false,
                loadingPasswordRecovery: false,
                passwordRecoverySuccess: false,
                email: '',
                password: '',
                emailRules: [
                    v => !!v || 'E-mail es obligatorio',
                    v => new RegExp(/.+@.+\..+/).test(v) || 'E-mail inválido'
                ],
                passwordRules: [
                    v => !!v || 'Contraseña es obligatoria',
                    v => v.length >= 6 || 'Debe tener al menos 6 caracteres'
                ],
            }
        },
        methods: {
                ...mapMutations(['showSnackBar']),
            show(){
                this.dialog = true
            },
            async passwordRecovery(){

                var vm = this
                if(!vm.valid){
                    vm.showSnackBar('El correo es inválido', 'pink')
                    return
                }
                if(vm.loadingPasswordRecovery === true) return

                vm.loadingPasswordRecovery = true
                const response = await ApiUtils.passwordResetEmail(vm.email)
                vm.loadingPasswordRecovery = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message, 'pink')
                    return
                }

                vm.passwordRecoverySuccess = true

            },
        }
    }
</script>